var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriangleShape = function SvgTriangleShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.118 2a2.492 2.492 0 0 0-1.909-.136 2.492 2.492 0 0 0-1.445 1.254L2.152 24.58a2.5 2.5 0 0 0 2.466 2.92l21.492-.107a2.5 2.5 0 0 0 1.508-3.511L17.236 3.118A2.5 2.5 0 0 0 16.118 2z",
    fillRule: "evenodd"
  })));
};
export default SvgTriangleShape;